import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { keyframes, cx, css } from 'emotion';
import ThemeContext from '@hig/theme-context';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_INCREASE_PER_MS = 1 / 1000;

var ProgressRingDeterminateBehavior = function (_Component) {
  _inherits(ProgressRingDeterminateBehavior, _Component);

  function ProgressRingDeterminateBehavior(props) {
    _classCallCheck(this, ProgressRingDeterminateBehavior);

    var _this = _possibleConstructorReturn(this, (ProgressRingDeterminateBehavior.__proto__ || Object.getPrototypeOf(ProgressRingDeterminateBehavior)).call(this, props));

    _this.state = {
      cssTransitionState: null,
      transitionEnter: true
    };

    _this.step = function (timestamp) {
      if (_this.state.cssTransitionState === "entering" || _this.state.cssTransitionState === "exiting") {
        _this.wait();
        return;
      }

      if (_this.state.cssTransitionState === "exited" && _this.value !== _this.targetValue) {
        _this.enter();
        return;
      }

      if (_this.targetValue === 1 && _this.value === 1 && _this.state.cssTransitionState !== "exited") {
        _this.exit();
        return;
      }

      _this.progressTowardTarget(timestamp);
    };

    _this.handleEntering = function () {
      _this.setState({ cssTransitionState: "entering" });
    };

    _this.handleEntered = function () {
      _this.setState({ cssTransitionState: "entered" });
      _this.setProgress(_this.props.percentComplete);
    };

    _this.handleExiting = function () {
      _this.setState({ cssTransitionState: "exiting" });
    };

    _this.handleExited = function () {
      _this.setState({ cssTransitionState: "exited" });
    };

    _this.refContainer = function (containerRef) {
      _this.containerRef = containerRef;
    };

    _this.value = 0;
    _this.prevTimestamp = 0;
    return _this;
  }

  _createClass(ProgressRingDeterminateBehavior, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.cssTransitionState === "entered" || this.state.cssTransitionState === "exited") {
        this.initSegments();
        this.setProgress(this.props.percentComplete);
      }
    }
  }, {
    key: "setProgress",
    value: function setProgress(percent) {
      this.targetValue = percent / 100;

      if (!this.prevTimestamp) {
        this.prevTimestamp = window.performance.now();
      }
      window.requestAnimationFrame(this.step);
    }
  }, {
    key: "setSegmentOpacities",
    value: function setSegmentOpacities(value) {
      var _this2 = this;

      this.segments.forEach(function (segment, i) {
        var index = Math.abs(i - _this2.SEGMENT_COUNT) - 1;
        var eachSegment = segment;
        eachSegment.style.opacity = _this2.opacityForSegment(index, value);
      });
    }
  }, {
    key: "initSegments",
    value: function initSegments() {
      this.segments = Array.from(this.containerRef.querySelectorAll(".hig__progress-ring__segment"));
      this.containerRef.querySelector(".hig__progress-ring__mask").style.opacity = null;
      this.SEGMENT_COUNT = this.segments.length;
      this.FADE_DELAY_FACTOR = 1 / this.SEGMENT_COUNT;
    }
  }, {
    key: "progressTowardTarget",
    value: function progressTowardTarget(timestamp) {
      var elapsed = timestamp - this.prevTimestamp;

      var valueDiff = void 0;
      if (this.targetValue > this.value) {
        valueDiff = Math.min(elapsed * MAX_INCREASE_PER_MS, this.targetValue - this.value);
      } else if (this.targetValue < this.value) {
        valueDiff = Math.max(-elapsed * MAX_INCREASE_PER_MS, this.targetValue - this.value);
      } else {
        if (this.state.cssTransitionState !== "exited") {
          this.setSegmentOpacities(this.value);
        }
        this.prevTimestamp = undefined;
        return;
      }

      var interrumValue = this.value + valueDiff;

      this.setSegmentOpacities(interrumValue);

      this.prevTimestamp = timestamp;
      this.value = interrumValue;

      window.requestAnimationFrame(this.step);
    }
  }, {
    key: "enter",
    value: function enter() {
      this.segments.forEach(function (segment) {
        var eachSegment = segment;
        eachSegment.style.opacity = 0;
      });
      this.setState({ transitionEnter: true });
      this.wait();
    }
  }, {
    key: "exit",
    value: function exit() {
      this.segments.forEach(function (segment) {
        var eachSegment = segment;
        eachSegment.style.opacity = null;
      });
      this.setState({ transitionEnter: false });
      this.wait();
    }
  }, {
    key: "wait",
    value: function wait() {
      this.prevTimestamp = window.performance.now();
      window.requestAnimationFrame(this.step);
    }
    /**
     * @param {HTMLDivElement} containerRef
     */


    /** @type {HTMLDivElement} */

  }, {
    key: "opacityForSegment",
    value: function opacityForSegment(index, value) {
      var fadeStartValue = index * this.FADE_DELAY_FACTOR;
      return Math.max(0, (value - fadeStartValue) / this.FADE_DELAY_FACTOR);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var innerRef = this.refContainer,
          percentComplete = this.percentComplete;


      return React.createElement(
        CSSTransition,
        {
          "in": this.state.transitionEnter,
          timeout: { enter: 650, exit: 466 },
          appear: true,
          classNames: "hig__progress-ring--",
          onEntering: this.handleEntering,
          onEntered: this.handleEntered,
          onExiting: this.handleExiting,
          onExited: this.handleExited
        },
        function (status) {
          return _this3.props.children({
            innerRef: innerRef,
            percentComplete: percentComplete,
            cssTransitionState: status
          });
        }
      );
    }
  }]);

  return ProgressRingDeterminateBehavior;
}(Component);

ProgressRingDeterminateBehavior.propTypes = {
  /**
   * An integer from 0 to 100 representing the percent the delayed operation has completed
   */
  percentComplete: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Render prop */
  children: PropTypes.func.isRequired
};
ProgressRingDeterminateBehavior.__docgenInfo = {
  "description": "",
  "displayName": "ProgressRingDeterminateBehavior",
  "props": {
    "percentComplete": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "An integer from 0 to 100 representing the percent the delayed operation has completed"
    },
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Render prop"
    }
  }
};

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CYCLE_DURATION = 1000;
var FADE_DURATION = 416;

var ProgressRingIndeterminateBehavior = function (_Component) {
  _inherits$1(ProgressRingIndeterminateBehavior, _Component);

  function ProgressRingIndeterminateBehavior(props) {
    _classCallCheck$1(this, ProgressRingIndeterminateBehavior);

    var _this = _possibleConstructorReturn$1(this, (ProgressRingIndeterminateBehavior.__proto__ || Object.getPrototypeOf(ProgressRingIndeterminateBehavior)).call(this, props));

    _this.state = {
      cssTransitionState: null
    };

    _this.step = function (timestamp) {
      if (!_this.playing) {
        return;
      }
      if (_this.state.cssTransitionState !== "entered") {
        window.requestAnimationFrame(_this.step);
        return;
      }

      if (!_this.startTime) _this.startTime = timestamp;
      var elapsed = timestamp - _this.startTime;
      var elapsedThisCycle = elapsed % CYCLE_DURATION;

      _this.setSegmentOpacities(elapsedThisCycle);

      window.requestAnimationFrame(_this.step);
    };

    _this.handleEntering = function () {
      _this.setState({ cssTransitionState: "entering" });
    };

    _this.handleEntered = function () {
      _this.setState({ cssTransitionState: "entered" });
      _this.start();
    };

    _this.handleExiting = function () {
      _this.setState({ cssTransitionState: "exiting" });
    };

    _this.handleExited = function () {
      _this.setState({ cssTransitionState: "exited" });
    };

    _this.refContainer = function (containerRef) {
      _this.containerRef = containerRef;
    };

    _this.startTime = undefined;
    return _this;
  }

  _createClass$1(ProgressRingIndeterminateBehavior, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.initSegments();
      this.step(1);
    }
  }, {
    key: "setSegmentOpacities",
    value: function setSegmentOpacities(elapsedThisCycle) {
      var _this2 = this;

      this.segments.forEach(function (segment, i) {
        var index = Math.abs(i - _this2.SEGMENT_COUNT) - 1;
        var eachSegment = segment;

        eachSegment.style.opacity = _this2.opacityForSegment(index, elapsedThisCycle);
      });
    }
  }, {
    key: "initSegments",
    value: function initSegments() {
      this.segments = Array.from(this.containerRef.querySelectorAll(".hig__progress-ring__segment"));

      this.containerRef.querySelector(".hig__progress-ring__mask").style.opacity = null;
      this.SEGMENT_COUNT = this.segments.length;
      this.SEGMENT_DELAY_FACTOR = CYCLE_DURATION / this.SEGMENT_COUNT;
    }

    /**
     * @param {HTMLDivElement} containerRef
     */


    /** @type {HTMLDivElement} */

  }, {
    key: "opacityForSegment",
    value: function opacityForSegment(index, elapsedThisCycle) {
      var segmentFadeStartTime = index * this.SEGMENT_DELAY_FACTOR;

      // Fade continuing from previous cycle
      if (segmentFadeStartTime + FADE_DURATION > CYCLE_DURATION && elapsedThisCycle < FADE_DURATION) {
        return ((elapsedThisCycle + CYCLE_DURATION - segmentFadeStartTime) / FADE_DURATION - 1) * -1;
      }

      // Fade has finished
      if (elapsedThisCycle < segmentFadeStartTime || elapsedThisCycle > segmentFadeStartTime + FADE_DURATION) {
        return 0;
      }

      // Fading
      return Math.abs((elapsedThisCycle - segmentFadeStartTime) / FADE_DURATION - 1);
    }
  }, {
    key: "start",
    value: function start() {
      this.playing = true;
      this.startTime = undefined;
      window.requestAnimationFrame(this.step);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var innerRef = this.refContainer;


      return React.createElement(
        CSSTransition,
        {
          "in": true,
          timeout: { enter: 650, exit: 466 },
          appear: true,
          classNames: "hig__progress-ring--",
          onEntering: this.handleEntering,
          onEntered: this.handleEntered,
          onExiting: this.handleExiting,
          onExited: this.handleExited
        },
        function (status) {
          return _this3.props.children({
            innerRef: innerRef,
            cssTransitionState: status
          });
        }
      );
    }
  }]);

  return ProgressRingIndeterminateBehavior;
}(Component);

ProgressRingIndeterminateBehavior.propTypes = {
  /** Render prop */
  children: PropTypes.func.isRequired
};
ProgressRingIndeterminateBehavior.__docgenInfo = {
  "description": "",
  "displayName": "ProgressRingIndeterminateBehavior",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "Render prop"
    }
  }
};

var _templateObject = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale(0);\n  }\n\n  61% {\n    transform: scale(1.1);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"], ["\n  from {\n    opacity: 0;\n    transform: scale(0);\n  }\n\n  61% {\n    transform: scale(1.1);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale(2);\n  }\n\n  55% {\n    opacity: 0;\n    transform: scale(1.6);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"], ["\n  from {\n    opacity: 0;\n    transform: scale(2);\n  }\n\n  55% {\n    opacity: 0;\n    transform: scale(1.6);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n    from {\n      opacity: 1;\n      transform: scale(1);\n      fill: ", ";\n    }\n\n    10% {\n      transform: scale(1.1);\n    }\n\n    60% {\n      opacity: 1;\n    }\n\n    to {\n      opacity: 0;\n      transform: scale(0);\n    }\n  "], ["\n    from {\n      opacity: 1;\n      transform: scale(1);\n      fill: ", ";\n    }\n\n    10% {\n      transform: scale(1.1);\n    }\n\n    60% {\n      opacity: 1;\n    }\n\n    to {\n      opacity: 0;\n      transform: scale(0);\n    }\n  "]),
    _templateObject4 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  10% {\n    transform: scale(1.2);\n  }\n\n  90% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0);\n  }\n"], ["\n  from {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  10% {\n    transform: scale(1.2);\n  }\n\n  90% {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0);\n  }\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  28% {\n    opacity: 0;\n  }\n"], ["\n  from {\n    opacity: 1;\n  }\n\n  28% {\n    opacity: 0;\n  }\n"]);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BackgroundEntering = keyframes(_templateObject);

var MaskEntering = keyframes(_templateObject2);

var BackgroundExiting = function BackgroundExiting(color) {
  return keyframes(_templateObject3, color);
};

var MaskExiting = keyframes(_templateObject4);

var SegmentsExiting = keyframes(_templateObject5);

function stylesheet(props, themeData) {
  var cssTransitionState = props.cssTransitionState,
      mask = props.mask,
      customStylesheet = props.stylesheet,
      surface = props.surface;


  var styles = {
    ring: {
      fontFamily: "ArtifaktElement",
      lineHeight: "1.6",
      boxSizing: "border-box",
      display: "flex",
      position: "relative",
      justifyContent: "center",
      alignItems: "center"
    },

    background: {
      transformOrigin: "center",
      fill: themeData["progress.ring.backgroundColor"]
    },

    mask: {
      transformOrigin: "center",
      fill: mask || themeData["colorScheme.surface.level" + surface]
    },

    segment: {
      opacity: 0,
      "&:nth-of-type(even)": {
        fill: themeData["progress.ring.highlightColor1"]
      },
      "&:nth-of-type(odd)": {
        fill: themeData["progress.ring.highlightColor2"]
      }
    }
  };

  if (cssTransitionState === "entering") {
    styles.background.animation = BackgroundEntering + " 0.65s ease-in-out";
    styles.mask.animation = MaskEntering + " 0.65s ease-out";
  } else if (cssTransitionState === "exiting") {
    styles.background.animation = BackgroundExiting(themeData["progress.ring.highlightColor1"]) + " 0.466s ease-in forwards";
    styles.mask.animation = MaskExiting + " 0.466s ease-in forwards";
    styles.segment.animation = SegmentsExiting + " 0.466s linear";
  } else if (cssTransitionState === "exited") {
    styles.mask.opacity = 0;
    styles.mask.transform = "scale(2)";
    styles.background.opacity = 0;
    styles.background.transform = "scale(0)";
  }

  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

function SVGPresenter(props) {
  var height = props.height,
      original = props.original,
      svgData = props.svgData,
      width = props.width;


  var buildPolygons = function buildPolygons(svgs, resolvedRoles) {
    return svgs.map(function (item) {
      // we need this if we don't want to manually edit
      // the svg files
      var map = {
        "hig__progress-ring__background": "background",
        "hig__progress-ring__mask": "mask",
        "hig__progress-ring__segment": "segment"
      };
      var styles = stylesheet(props, resolvedRoles)[map[item.className]];
      return React.createElement("polygon", {
        key: item.points,
        className: cx(item.className, css(styles)),
        fill: item.fill,
        fillRule: item.fillRule,
        points: item.points
      });
    });
  };

  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref) {
      var resolvedRoles = _ref.resolvedRoles;
      return React.createElement(
        "svg",
        {
          width: width,
          height: height,
          viewBox: "0 0 " + original + " " + original,
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          xmlnsXlink: "http://www.w3.org/1999/xlink"
        },
        buildPolygons(svgData, resolvedRoles)
      );
    }
  );
}

SVGPresenter.propTypes = {
  height: PropTypes.number,
  original: PropTypes.number,
  svgData: PropTypes.arrayOf(PropTypes.object),
  width: PropTypes.number
};
SVGPresenter.__docgenInfo = {
  "description": "",
  "displayName": "SVGPresenter",
  "props": {
    "height": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "original": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "svgData": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "object"
        }
      },
      "required": false,
      "description": ""
    },
    "width": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    }
  }
};

var smallSVG = [{
  className: "hig__progress-ring__background",
  points: "22.49 5.51 14 2 5.51 5.51 2 14 5.51 22.49 14 26 22.49 22.49 26 14"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "5.52 5.52 14 6.33 14 2"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "5.52 5.52 8.58 8.58 14 6.33"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "2 14 8.58 8.58 5.52 5.52"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "2 14 6.33 14 8.58 8.58"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "5.52 22.48 6.33 14 2 14"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "5.52 22.48 8.58 19.42 6.33 14"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "14 26 8.58 19.42 5.52 22.48"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "14 26 14 21.67 8.58 19.42"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "22.48 22.48 14 21.67 14 26"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "22.48 22.48 19.42 19.42 14 21.67"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "26 14 19.42 19.42 22.48 22.48"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "26 14 21.67 14 19.42 19.42"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "22.48 5.52 21.67 14 26 14"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "22.48 5.52 19.42 8.58 21.67 14"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "14 2 19.42 8.58 22.48 5.52"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "14 2 14 6.33 19.42 8.58"
}, {
  className: "hig__progress-ring__mask",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "19.42 19.42 14 21.67 8.58 19.42 6.33 14 8.58 8.58 14 6.33 19.42 8.58 21.67 14"
}];

var mediumSVG = [{
  className: "hig__progress-ring__background",
  points:
  /* eslint-disable-next-line max-len */
  "54.81 10.11 36 4 17.19 10.11 5.57 26.11 5.57 45.89 17.19 61.89 36 68 54.81 61.89 66.43 45.89 66.43 26.11"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "36 10.31 36 4 17.19 10.11"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0CA899",
  fillRule: "nonzero",
  points: "36 10.31 17.19 10.11 20.9 15.215"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "20.9 15.215 17.19 10.11 5.565 26.11"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0CA899",
  fillRule: "nonzero",
  points: "20.9 15.215 5.565 26.11 11.565 28.06"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "11.565 28.06 5.565 26.11 5.565 45.89"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0CA899",
  fillRule: "nonzero",
  points: "11.565 28.06 5.565 45.89 11.565 43.94"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "11.565 43.94 5.565 45.89 17.19 61.89"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0CA899",
  fillRule: "nonzero",
  points: "11.565 43.94 17.19 61.89 20.9 56.785"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "20.9 56.785 17.19 61.89 36 68"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0CA899",
  fillRule: "nonzero",
  points: "20.9 56.785 36 68 36 61.69"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "36 61.69 36 68 54.81 61.89"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0CA899",
  fillRule: "nonzero",
  points: "36 61.69 54.81 61.89 51.1 56.785"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "51.1 56.785 54.81 61.89 66.435 45.89"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0CA899",
  fillRule: "nonzero",
  points: "51.1 56.785 66.435 45.89 60.435 43.94"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "60.435 43.94 66.435 45.89 66.435 26.11"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0CA899",
  fillRule: "nonzero",
  points: "60.435 43.94 66.435 26.11 60.435 28.06"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "60.435 28.06 66.435 26.11 54.81 10.11"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0CA899",
  fillRule: "nonzero",
  points: "60.435 28.06 54.81 10.11 51.1 15.215"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "51.1 15.215 54.81 10.11 36 4"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0CA899",
  fillRule: "nonzero",
  points: "51.1 15.215 36 4 36 10.31"
}, {
  className: "hig__progress-ring__mask",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points:
  /* eslint-disable-next-line max-len */
  "60.43 43.94 51.1 56.78 36 61.69 20.9 56.78 11.57 43.94 11.57 28.06 20.9 15.22 36 10.31 51.1 15.22 60.43 28.07"
}];

var xsmallSVG = [{
  className: "hig__progress-ring__background",
  fillRule: "nonzero",
  points: "10 2 10 2 3.07 6 3.07 14 3.07 14 10 18 10 18 16.93 14 16.93 14 16.93 6"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "10 5.46 10 2 3.07 6 3.07 6"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "6.07 7.73 10 5.46 3.07 6 3.07 6"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "6.07 7.73 3.07 6 3.07 14 3.07 14"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "6.07 12.27 6.07 7.73 3.07 14 3.07 14"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "6.07 12.27 3.07 14 10 18 10 18"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "10 14.54 6.07 12.27 10 18 10 18"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "10 14.54 10 18 16.93 14 16.93 14"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "13.93 12.27 10 14.54 16.93 14 16.93 14"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "13.93 12.27 16.93 14 16.93 6 16.93 6"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "13.93 7.73 13.93 12.27 16.93 6 16.93 6"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "13.93 7.73 16.93 6 10 2 10 2"
}, {
  className: "hig__progress-ring__segment",
  fill: "#0ED3BE",
  fillRule: "nonzero",
  points: "10 5.46 13.93 7.73 10 2 10 2"
}, {
  className: "hig__progress-ring__mask",
  fill: "#FFFFFF",
  points: "13.93 12.27 10 14.54 6.07 12.27 6.07 7.73 10 5.46 13.93 7.73"
}];

var availableSizes = Object.freeze(["xs", "s", "m", "l", "xl"]);
var availableSurfaces = Object.freeze([100, 200, 250, 300, 350]);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var sizes = {
  xs: {
    svg: xsmallSVG,
    size: 20
  },
  s: {
    svg: smallSVG,
    size: 28
  },
  m: {
    svg: mediumSVG,
    size: 72
  },
  l: {
    svg: mediumSVG,
    size: 144
  },
  xl: {
    svg: mediumSVG,
    size: 242
  }
};

function ProgressRingPresenter(props) {
  var innerRef = props.innerRef,
      percentComplete = props.percentComplete,
      size = props.size,
      cssTransitionState = props.cssTransitionState,
      surface = props.surface,
      mask = props.mask,
      otherProps = _objectWithoutProperties(props, ["innerRef", "percentComplete", "size", "cssTransitionState", "surface", "mask"]);

  var className = otherProps.className;

  var SVG = sizes[size].svg;
  var originalSize = sizes[size].svg === mediumSVG ? 72 : sizes[size].size;

  return React.createElement(
    "div",
    {
      className: cx([className, css(stylesheet(props, {}).ring)]),
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": percentComplete,
      ref: innerRef
    },
    React.createElement(SVGPresenter, _extends({
      height: sizes[size].size,
      width: sizes[size].size,
      original: originalSize,
      svgData: SVG,
      cssTransitionState: cssTransitionState,
      surface: surface,
      mask: mask
    }, otherProps))
  );
}

ProgressRingPresenter.defaultProps = { size: "m", surface: 100 };

ProgressRingPresenter.propTypes = {
  cssTransitionState: PropTypes.string,
  innerRef: PropTypes.func,
  mask: PropTypes.string,
  percentComplete: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(availableSizes),
  stylesheet: PropTypes.func,
  surface: PropTypes.oneOf(availableSurfaces)
};
ProgressRingPresenter.__docgenInfo = {
  "description": "",
  "displayName": "ProgressRingPresenter",
  "props": {
    "cssTransitionState": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "mask": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "percentComplete": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": ""
    },
    "size": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "availableSizes"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "\"m\"",
        "computed": false
      }
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "surface": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "availableSurfaces"
      },
      "required": false,
      "description": "",
      "defaultValue": {
        "value": "100",
        "computed": false
      }
    }
  }
};

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressRing = function (_Component) {
  _inherits$2(ProgressRing, _Component);

  function ProgressRing() {
    _classCallCheck$2(this, ProgressRing);

    return _possibleConstructorReturn$2(this, (ProgressRing.__proto__ || Object.getPrototypeOf(ProgressRing)).apply(this, arguments));
  }

  _createClass$2(ProgressRing, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          mask = _props.mask,
          percentComplete = _props.percentComplete,
          size = _props.size,
          stylesheet = _props.stylesheet,
          surface = _props.surface,
          otherProps = _objectWithoutProperties$1(_props, ["mask", "percentComplete", "size", "stylesheet", "surface"]);

      var ProgressRingBehavior = percentComplete === undefined ? ProgressRingIndeterminateBehavior : ProgressRingDeterminateBehavior;
      var behaviorProps = percentComplete === undefined ? {} : { percentComplete: percentComplete };

      return React.createElement(
        ProgressRingBehavior,
        behaviorProps,
        function (_ref) {
          var innerRef = _ref.innerRef,
              cssTransitionState = _ref.cssTransitionState;
          return React.createElement(ProgressRingPresenter, _extends$1({
            innerRef: innerRef,
            percentComplete: percentComplete,
            size: size,
            cssTransitionState: cssTransitionState,
            stylesheet: stylesheet,
            surface: surface,
            mask: mask
          }, otherProps));
        }
      );
    }
  }]);

  return ProgressRing;
}(Component);

ProgressRing.propTypes = {
  /**
   * Specifies a background color
   * If both surface & mask are provided, the value of mask will be used
   */
  mask: PropTypes.string,
  /**
   * An integer from 0 to 100 representing the percent the delayed operation has completed.
   * If left blank or this prop is omitted you will have the indeterminate progress ring
   */
  percentComplete: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * {xs, s, m, l, xl} the size of the progress indicator
   */
  size: PropTypes.oneOf(availableSizes),
  /**
   * Adds custom/overriding styles
   */
  stylesheet: PropTypes.func,
  /**
   * Specifies the surface level for the background
   */
  surface: PropTypes.oneOf(availableSurfaces)
};
ProgressRing.defaultProps = {
  size: "m",
  surface: 100
};
ProgressRing.__docgenInfo = {
  "description": "",
  "displayName": "ProgressRing",
  "props": {
    "mask": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Specifies a background color\nIf both surface & mask are provided, the value of mask will be used"
    },
    "percentComplete": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "An integer from 0 to 100 representing the percent the delayed operation has completed.\nIf left blank or this prop is omitted you will have the indeterminate progress ring"
    },
    "size": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "availableSizes"
      },
      "required": false,
      "description": "{xs, s, m, l, xl} the size of the progress indicator",
      "defaultValue": {
        "value": "\"m\"",
        "computed": false
      }
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Adds custom/overriding styles"
    },
    "surface": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "availableSurfaces"
      },
      "required": false,
      "description": "Specifies the surface level for the background",
      "defaultValue": {
        "value": "100",
        "computed": false
      }
    }
  }
};

export default ProgressRing;
